import React from 'react';
import { motion } from 'framer-motion';
import { RESUME_SUMMARY, EDUCATION, SKILL_GROUPS, LANGUAGES, LINKS } from '../../constants';
import FlipButton from '../UI/FlipButton';

const About: React.FC = () => {
  return (
    <div className='space-y-16'>
      {/* Bio */}
      <section className='grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-start'>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className='w-44 sm:w-56 mx-auto md:mx-0'
        >
          <img
            src='/Assets/Photo.jpg'
            alt='Akash Roy'
            className='w-full aspect-[4/5] object-cover rounded-2xl border border-line'
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className='label-mono text-gray2 mb-3'>
            <span className='text-accent'>[</span> Akash Roy <span className='text-accent'>]</span>
          </div>
          <h3 className='font-medium tracking-tight text-2xl sm:text-3xl text-ink mb-4'>
            Business Transformation Manager, PMO &amp; Transformation
          </h3>
          <p className='text-gray1 leading-relaxed max-w-2xl'>{RESUME_SUMMARY}</p>
          <div className='mt-6 flex flex-wrap gap-3'>
            <FlipButton label='Download résumé' href={LINKS.resume} variant='dark' size='sm' />
            <FlipButton
              label='LinkedIn'
              href={LINKS.linkedin}
              variant='outline'
              size='sm'
              className='text-ink'
            />
          </div>
        </motion.div>
      </section>

      {/* Education */}
      <section>
        <div className='label-mono text-gray2 mb-5'>Education</div>
        <div className='border-t border-line'>
          {EDUCATION.map((edu, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className='py-6 border-b border-line flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-2'
            >
              <div>
                <h3 className='font-medium tracking-tight text-lg text-ink'>{edu.degree}</h3>
                <div className='text-sm text-gray1 mt-1'>{edu.major}</div>
                <div className='label-mono !text-[10px] text-gray2 mt-2'>
                  {edu.institution}, {edu.location}
                </div>
              </div>
              <span className='label-mono text-gray2'>{edu.year}</span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Skills */}
      <section>
        <div className='label-mono text-gray2 mb-5'>Skills</div>
        <div className='border-t border-line'>
          {SKILL_GROUPS.map((group, gi) => (
            <motion.div
              key={group.title}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: gi * 0.07, duration: 0.5 }}
              className='grid grid-cols-1 sm:grid-cols-[220px_1fr] gap-2 sm:gap-8 py-6 border-b border-line'
            >
              <h3 className='font-medium tracking-tight text-base text-ink'>{group.title}</h3>
              <div className='flex flex-wrap gap-x-5 gap-y-1.5'>
                {group.items.map(item => (
                  <span key={item} className='text-sm text-gray1'>
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
          <div className='grid grid-cols-1 sm:grid-cols-[220px_1fr] gap-2 sm:gap-8 py-6 border-b border-line'>
            <h3 className='font-medium tracking-tight text-base text-ink'>Languages</h3>
            <div className='flex flex-wrap gap-x-5 gap-y-1.5'>
              {LANGUAGES.map(lang => (
                <span key={lang} className='text-sm text-gray1'>
                  {lang}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
